
import React from 'react';
import { MessageSquare, FileText, BarChart, Database } from 'lucide-react';
import FeatureBox from './FeatureBox';

const BenefitsSection = () => {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container max-w-4xl mx-auto px-4">
        <div className="text-center mb-12 reveal">
          <h2 className="text-3xl md:text-4xl font-semibold mb-6">Benefits</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Transform how your organization interacts with data, making insights accessible to everyone regardless of technical skill level.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 reveal">
          <FeatureBox 
            icon={MessageSquare}
            title="Natural Language Access"
            description="Ask questions in plain language without needing to understand complex query languages or report structures."
          />
          
          <FeatureBox 
            icon={FileText}
            title="Instant Answers"
            description="Get immediate responses to your data questions without navigating through multiple dashboards."
          />
          
          <FeatureBox 
            icon={BarChart}
            title="Rich Visualizations"
            description="Receive answers as text, charts, or downloadable datasets depending on your needs."
          />
          
          <FeatureBox 
            icon={Database}
            title="Works with Existing Data"
            description="Leverage your current data infrastructure without massive overhauls or migrations."
          />
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
